import { ServiceProvider } from "@osjs/common";

export class SearchServiceProvider extends ServiceProvider {
    constructor(core, options = {}) {
        super(core, options || {});
        this.core = core;
    }

    providers() {
        return ["oxzion/search"];
    }

    init() {
        this.core.instance("oxzion/search", () => ({
            delayedSearch: (fn, delay) => this.delayedSearch(fn, delay),
        }));
    }

    delayedSearch = (fn, delay) => {
        let timerId;
        return (...args) => {
            if (timerId) {
                clearTimeout(timerId);
            }

            timerId = setTimeout(() => fn(...args), delay);
        };
    };
}